export default "__VITE_ASSET__Re6cQqqC__"